import React from 'react';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";

export default function DashboardLanguageMenu(props) {

    const langPref = props.beagleLanguagePreference ? props.beagleLanguagePreference : 'en';


    let labelEnglish = "English";

    let labelSpanish = "Spanish";
    if (langPref === 'es') {
        labelSpanish = 'Español';
    }

    let labelFrench = "French";
    if (langPref === 'fr') {
        labelFrench = 'Français';
    }

    let labelPortuguese = "Portuguese";
    if (langPref === 'pt') {
        labelPortuguese = 'Português';
    }

    let labelRussian = "Russian";
    if (langPref === 'ru') {
        labelRussian = 'Русский';
    }

    let labelChinese = "Chinese";
    if (langPref === 'zh') {
        labelChinese = '中文';
    }


    //{e => setValue(e.target.value)}
    // onChange={props.handleChangeLangPref ? props.handleChangeLangPref : 'en'}

    return (
        <FormControl>
            <Select
                labelId="lang-select-label"
                id="lang-select"
                value={langPref}
                onChange={e => props.handleChangeLangPref(e.target.value)}
            >
                <MenuItem value={"en"}>{labelEnglish}</MenuItem>
                <MenuItem value={"es"}>{labelSpanish}</MenuItem>
                <MenuItem value={"fr"}>{labelFrench}</MenuItem>
                <MenuItem value={"pt"}>{labelPortuguese}</MenuItem>
                <MenuItem value={"ru"}>{labelRussian}</MenuItem>
                <MenuItem value={"zh"}>{labelChinese}</MenuItem>
            </Select>

        </FormControl>
    );
}
